import { useVehiclesSocketStore } from "../../../store/admin/vehiclesSocketStore";
import { useCompaniesStore } from "../../../store/admin/companiesStore";
import { ADMIN_RESELLER_ROLE_ID } from "../../../hooks/useIsReseller";

export const useFleetCompanyScope = (): string | null => {
  const isReseller =
    (localStorage.getItem("userRoleId") || "") === ADMIN_RESELLER_ROLE_ID;
  const selectedCompany = useVehiclesSocketStore(
    (state) => state.selectedCompany
  );
  const companyUser = useCompaniesStore((state) => state.companyUser);

  if (isReseller) {
    return selectedCompany || localStorage.getItem("companyId");
  }
  return companyUser || localStorage.getItem("userCompanyId");
};
